import { InstructorRolesStore } from './instructor-roles-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new InstructorRolesStore());
}
